module.exports = __webpack_public_path__ + "img/Seattle-Women.fd5ebd9f.jpg";